"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardAdd = void 0;
const react_1 = __importStar(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const Card_1 = __importDefault(require("@material-ui/core/Card"));
const CardContent_1 = __importDefault(require("@material-ui/core/CardContent"));
const IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
const Add_1 = __importDefault(require("@material-ui/icons/Add"));
const dashboard_context_1 = require("../../dashboard-context");
const card_styles_1 = require("../card-styles");
function CardAdd() {
    const classes = (0, card_styles_1.useStyles)();
    const { openAddDialog } = (0, react_1.useContext)(dashboard_context_1.DashboardContext);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Card_1.default, { onClick: openAddDialog, variant: "outlined", className: (0, clsx_1.default)(classes.card, classes.cardAdd) },
            react_1.default.createElement(CardContent_1.default, { className: classes.cardAddContent },
                react_1.default.createElement(IconButton_1.default, { color: "primary" },
                    react_1.default.createElement(Add_1.default, null))))));
}
exports.CardAdd = CardAdd;
//# sourceMappingURL=card-add.js.map